module.exports = __webpack_public_path__ + "img/sms-new.c58a1dab.svg";